import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import Item from "./item";
export interface IProps {
  title?: string;
  itemCss?: string;
  imgBoxCss?: string;
  urlParams?: string;
  clickOpenNewPage?: boolean;
  maxLengthShowBtn?: number;
  moreTitle?: string;
  moreHref?: string;
  dataSource: any[];
  onChange?: (data?: any) => void;
}

export interface INavData {
  key: string;
  name: string;
  total: number;
}

export interface IListData {
  key: string;
  name: string;
  total: number;
}

const MoviesShort: React.FC<IProps> = (props: IProps) => {
  const {
    title,
    dataSource,
    maxLengthShowBtn = 3,
    urlParams = "",
    itemCss = "w-auto",
    clickOpenNewPage = true,
    imgBoxCss = "w-full h-374",
    moreTitle,
    moreHref,
  } = props;
  const targetRef = useRef<HTMLDivElement>(null);
  const [left, setLeft] = useState<boolean>(true);
  const [right, setRight] = useState<boolean>(false);


  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  const onScroll = useCallback((e) => {
    const element = e.currentTarget;
    const scrollLeft = element.scrollLeft;
    const scrollWidth = element.scrollWidth;
    const clientWidth = element.clientWidth;

    const scrollRight = scrollWidth - clientWidth;
    setRight(scrollLeft >= scrollRight);
    setLeft(scrollLeft === 0);
  }, []);

  const checkWidth = useCallback(() => {
    if (targetRef.current) {
      const { scrollWidth, clientWidth } = targetRef.current;
      scrollWidth > clientWidth ? setRight(false) : setRight(true);
    }
  }, []);


  useEffect(() => {
    targetRef.current!.addEventListener("scroll", onScroll);
    window.addEventListener("resize", checkWidth);

    checkWidth();
    targetRef.current!.scrollTo(0, 0);
    return () => {
      targetRef.current!.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", checkWidth);
    };
  }, [dataSource]);

  return (
    <section id='MoviesShortSelect' className='w-full'>
      <div className='w-full'>
        {(title || moreHref) && (
          <div className='flex items-center justify-between mt-20'>
            {title && <div className='text-24 font-bold text-left text-[#333] leading-30'>{title}</div>}
            {moreHref && (
              <a href={moreHref} className='MoviesShortMoreBtn text-16 text-[#333] leading-30'>
                {moreTitle}
              </a>
            )}
          </div>
        )}

        <div className='relative mt-16 h-auto'>
          {!left && (
            <i
              className='w-22 h-60 block absolute left-0 top-[120px] z-10'
              style={{
                backgroundImage: `url(https://photo.8891.com.tw/2024/06/18/1718703170048109.png)`,
                backgroundSize: "100%",
              }}
              onClick={() => scrollTo(-864)}
            />
          )}
          {!right && (
            <i
              className='w-22 h-60 block absolute right-0 top-[120px] z-10'
              style={{
                backgroundImage: `url(https://photo.8891.com.tw/2024/06/18/1718703170003603.png)`,
                backgroundSize: "100%",
              }}
              onClick={() => scrollTo(864)}
            />
          )}

          <div
            className='flex gap-20 scroll-smooth overflow-auto scrollbar-hide border-box'
            ref={targetRef}
            style={{ scrollbarWidth: "none", scrollbarColor: "transparent transparent" }}
          >
            {dataSource.map((item: any, index) => (
              <div
                className={`h-fit rounded-8 relative ${itemCss}`}
                style={{ marginRight: dataSource.length !== index + 1 ? "revert-layer" : "0" }}
                key={index}
              >
                <Item data={item} urlParams={urlParams} clickOpenNewPage={clickOpenNewPage} imgBoxCss={imgBoxCss} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default memo(MoviesShort);
